<template>
    <!-- 动画  数字加 -->
    <div v-if="counterStyle === 5" class="myCounter">
        <div class="counterChange"
             v-for="(counter, index) in counterData"
             :key="index">
            <div :class="`count-box counter-style-4 ${checkTextAlign}`">
                 <p class="counter-title">{{ counter.title }}</p>
                <VisibilitySensor @change="onChange">
                    <div class="count-number">
                        <countTo
                            :endVal="status ? counter.number : 0"
                            :autoplay="countUp"
                            :duration="3000"
                            :separator="index === 0 ? '' : ','"
                        />
                        <span v-if="index !== 0" class="plus">+</span>
                        <p v-if="index === 0" class="nian">年</p>
                    </div>
                </VisibilitySensor>
               
                <!-- <p >{{ counter.title2 }}</p> -->
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.myCounter {
    display: flex;
    justify-content: space-between;
    gap: 20px;

    .counterChange {
        width: 172px;
        height: 83px;
        background-image: linear-gradient(203deg, rgba(235, 245, 255, 0.45) 0%, rgba(246, 250, 255, 0.45) 100%);
        border-radius: 4px;
        padding: 0 10px 0 16px;
        
        .counter-style-4 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            margin-top: 0;
            
            .counter-title {
                color: #667085;
                font-size: 14px;
                margin-bottom: 2px;
                text-align: left;
            }

            .count-number {
                font-size: 26px;
                font-weight: bold;
                display: flex;
                align-items: center;
                text-align: left;
                line-height: 1.2;
            }
        }

        /* 第一个卡片：黑色文字 */
        &:nth-child(1) {
            .count-number {
                color: #101828;
                .nian {
                    display: inline-block;
                    font-size: 20px;
                    margin-left: 4px;
                    color: #101828;
                    margin-bottom: 0;
                }
            }
        }

        /* 后两个卡片：蓝色文字 */
        &:nth-child(2), &:nth-child(3) {
            .count-number {
                color: #1570EF;
                .plus {
                    font-size: 30px;
                    margin-left: 2px;
                }
            }
        }
    }
}
</style>
<script>
    import VisibilitySensor from 'vue-visibility-sensor'
    import countTo from 'vue-count-to'

    export default {
        name: 'Counter',
        components: {VisibilitySensor, countTo},
        props: {
            counterData: {},
            counterStyle: {
                type: Number,
                default: 1
            },
            textAlign: {
                type: String,
                default: 'left'
            }
        },
        data() {
            return {
                countUp: true,
                status: false
            }
        },
        computed: {
            checkTextAlign() {
                if (this.textAlign === 'left') return 'text-start';
                else if (this.textAlign === 'center') return 'text-center';
                else if (this.textAlign === 'end') return 'text-end';
                else return '';
            }
        },
        methods: {
            onChange(isVisible) {
                if (isVisible) {
                    this.status = true;
                }
            }
        }
    }
</script>